module.exports = __webpack_public_path__ + "img/portugal-leukaemia-female.9f3b81dd.png";